import axios from "axios";
import * as Sentry from "@sentry/react";

const setUserIfNeeded = () => {
  const scope = Sentry.getCurrentScope();
  if (!scope.getUser()) {
    const userMeta = document.querySelector('meta[name="current-user"]');
    if (userMeta) {
      try {
        const userData = JSON.parse(userMeta.getAttribute("content") || "{}");
        Sentry.setUser({
          id: userData.id,
          email: userData.email,
          username: userData.username,
        });
      } catch (e) {
        console.error("Error parsing current-user meta", e);
      }
    }
  }
};

// Breadcrumb interceptor para requests
axios.interceptors.request.use(
  config => {
    Sentry.addBreadcrumb({
      category: 'axios',
      message: `Request: ${config.method.toUpperCase()} ${config.url}`,
      level: 'info',
      data: {
        method: config.method,
        url: config.url,
      },
    });
    return config;
  },
  error => Promise.reject(error)
);

// ➡Interceptor para capturar errores de API
axios.interceptors.response.use(
  response => response,
  error => {
    setUserIfNeeded();

    if (error.response) {
      const { status, config, data } = error.response;

      if (status >= 500 || status === 401 || status === 403) {
        Sentry.captureException(error, {
          tags: {
            type: "axios",
            status,
            method: config.method,
            url: config.url,
          },
          extra: {
            requestData: config.data,
            responseData: data,
          },
        });
      }
    } else if (error.request) {
      Sentry.captureException(error, {
        tags: { type: "axios", status: "network" },
        extra: { request: error.request },
      });
    } else {
      Sentry.captureException(error, {
        tags: { type: "axios", status: "setup-error" },
        extra: { message: error.message },
      });
    }

    return Promise.reject(error);
  }
);
